import React from "react"
import { Information, arrowDownRight, arrowTopRight, info } from "../../images"
import "./CheckOut.css"
import { useState, useEffect } from "react"
import { apiEndPoints } from "constants/apiEndpoints"
import BottomBar from "../BottomBar/bottombar"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { http } from "utils/http"
import { useHistory } from "react-router"
import momentZone from "moment-timezone"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { SuccessTick } from "../index"
import { useTranslation } from "react-i18next"

const CheckOut = () => {
  const { t } = useTranslation()
  let timerID: ReturnType<typeof setTimeout>
  const history: any = useHistory()
  const dispatch = useDispatch()
  const [successDisable, setSuccessDisable] = useState(false)
  const matchingVisitDetails = useSelector(
    (state: RootState) =>
      state.appointmentReducer.appointment?.matchingVisitDetails
  )

  const visitObj = useSelector(
    (state: RootState) => state.visitReducer.visit?.visit
  )
  const visitId = matchingVisitDetails?.id || visitObj?.visit?.id
  const direction_fetch = useSelector(
    (state: RootState) => state.directionReducer.direction[0]?.direction
  )

  const offset = direction_fetch?.timezone?.offset
  const timeZoneName = direction_fetch?.timezone?.name
  if (direction_fetch) {
    var {
      trailerType,
      referenceNumber,
      appointmentTime,
      equipment: {
        carrier: { name: equipmentCarrierName, scac: equipmentCarrierScac },
        id: EquipmentID,
        type: EquipmentType
      },
      timezone: { name: TimeZoneName, offset: timeZoneOffset }
    } = direction_fetch
  }
  const offsetDate = momentZone(appointmentTime).utcOffset(offset / 3600)
  let carrierName = equipmentCarrierName
  if (direction_fetch && equipmentCarrierScac !== "") {
    carrierName = `${carrierName} [ ${equipmentCarrierScac}]`
  }
  let appointmentTimeShow = "NA"
  if (appointmentTime) {
    appointmentTimeShow = `${offsetDate.format("ddd")}, ${offsetDate.format(
      "MMM DD"
    )} ${offsetDate.format("LT")} ${timeZoneName}`
  }

  const gotoVisitSummary = () => {
    http
      .post(
        `${apiEndPoints.activities}${visitId}/activities`,
        {
          type: "check-out"
        },
        {}
      )
      .then(() => true)
      .catch(() => true)
    http
      .post(
        `${apiEndPoints.fetchSummary}`,
        {
          visitId: visitId
        },
        {}
      )
      .then(response => {
        dispatch({
          type: "SET_VISIT_SUMMARY",
          payload: [
            {
              visitSummary: response.data.data
            }
          ]
        })
        setSuccessDisable(true)
        timerID = setTimeout(() => {
          setSuccessDisable(false)
          history.push("/visitsummary")
        }, 2000)
      })
  }
  return (
    <>
      <div className={`container`}>
        <SuccessTick
          message={t("check_out_successful")}
          proceedMessage=""
          visible={successDisable}
        />
        <div className="checkout-header accord-container">
          <div>
            <img className="checkout--info-img" src={Information} alt="info" />
          </div>
          <div style={{ marginLeft: "16px" }}>
            <div className="to-check-out">{t("to_check_out")}</div>
            <div>{t("show_to_guard_text")}</div>
          </div>
        </div>
        <div className="accord-container">
          {!direction_fetch && (
            <div className="accord-header" style={{ position: "relative" }}>
              <img
                className="accord-header-image"
                src={arrowTopRight}
                alt={arrowTopRight}
              />
              <div className="accord-header-text" style={{ width: "300px" }}>
                {t("what_is_going_out")}
              </div>
              <div className="trailer-type">
                <span className="trailer-type-text">{t("empty")}</span>
              </div>
            </div>
          )}
          {direction_fetch &&
            summaryDetails({
              header: t("what_is_going_out"),
              trailerType: trailerType,
              icon: "View",
              checkout: [
                {
                  key: "Reference Number",
                  value: referenceNumber || "NA"
                },
                {
                  key: "Appointment Time",
                  value: appointmentTimeShow || "NA"
                },
                {
                  key: "Equipment Type",
                  value: EquipmentType || "NA"
                },
                {
                  key: "Equipment ID",
                  value: EquipmentID || "NA"
                },
                {
                  key: "Equipment Carrier",
                  value: carrierName || "NA"
                }
              ]
            })}
        </div>
        <div
          className="warning-info warning-info-driver"
          style={{ marginBottom: "16px" }}
        >
          <img className="warning-info-img" src={info} alt="info" />
          <div className="warning-info-text">
            <p className="margin-top">{t("visit_summary_text")}</p>
          </div>
        </div>
      </div>
      <BottomBar
        disabled={false}
        onClick={() => gotoVisitSummary()}
        text={t("view_visit_summary")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}

interface summaryDetailProps {
  header: string
  icon: string
  trailerType: string
  checkout: any
}

const summaryDetails = (props: summaryDetailProps) => {
  return (
    <>
      <div className="accord-header" style={{ position: "relative" }}>
        <img
          className="accord-header-image"
          src={props.icon === "arrowDownRight" ? arrowDownRight : arrowTopRight}
          alt={props.icon}
        />
        <div className="accord-header-text" style={{ width: "300px" }}>
          {props.header}
        </div>
        {props.trailerType != "" && (
          <div className="trailer-type">
            <span className="trailer-type-text">{props.trailerType}</span>
          </div>
        )}
      </div>
      <div>
        {props.checkout.map((item: any) => {
          return (
            <div className="accord-items" key={item.key}>
              <div className="accord-item-key">{item.key}</div>
              <div className="accord-item-value">{item.value}</div>
            </div>
          )
        })}
      </div>
    </>
  )
}
export default CheckOut
